import { t } from 'i18next'
import React, { useCallback, useMemo, useState } from 'react'
import { Button, Form, Alert, Modal } from 'react-bootstrap'
import { MdLibraryAdd } from 'react-icons/md'
import { useLocalInventoriesState } from '../../stores/LocalInventoriesProvider'
import { formatedDate } from '../../utils/formatedDate'
import { ButtonWithLoadingState } from '../Buttons'
import UniversalTableWrapperTest from '../Table/UniversalTableWrapperTest'
import BootstrapTable from 'react-bootstrap-table-next'
import { useTableState } from '../Table/TableProvider'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils'
import { APIEndpoints } from '../../utils/api/apiConfig'
import apiClient from '../../utils/api/apiClient'
import { DeleteIcon } from '../Icons/DeleteIcon'
import { isEmptyGuid } from '../../utils/emptyGuid'
import { isNumeric } from '../../utils/objectutils'
import cellEditFactory from 'react-bootstrap-table2-editor'
import styled from 'styled-components'

export const ResponsiveButton = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
  button {
    width: auto;
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
`

const StyledHeaderCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const UpdateLocalInventoriesModal = ({
  setShowUpdateLocalInventoriesModal,
}) => {
  const {
    setModifiedLocalInventories,
    modifiedLocalInventories,
    handleLocalChangeCheckbox,
    resetModifiedSelections,
    setForceReloadLocalInventories,
  } = useLocalInventoriesState()
  const [comment, setComment] = useState('')
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const { tableRef } = useTableState()
  const columns = useMemo(
    () => [
      {
        dataField: 'articleNumber',
        text: 'localInventoriesTable:articleNumber',
        sort: true,
        editable: false,
      },
      {
        dataField: 'articleName',
        text: 'localInventoriesTable:articleName',
        sort: true,
        editable: false,
      },
      {
        dataField: 'sizeName',
        text: 'localInventoriesTable:sizeName',
        sort: true,
        editable: false,
      },
      {
        dataField: 'serialkey',
        text: 'localInventoriesTable:serialkey',
        sort: true,
        editable: false,
      },
      {
        dataField: 'batchKey',
        text: 'localInventoriesTable:batchKey',
        sort: true,
        editable: false,
      },
      {
        dataField: 'expiryDate',
        text: 'localInventoriesTable:expiryDate',
        sort: true,
        editable: false,
        formatter: (cell, row) => formatedDate(cell),
      },
      {
        dataField: 'storehouseCoordinates',
        text: 'localInventoriesTable:storehouseCoordinates',
        editable: false,
        sort: true,
      },
      {
        dataField: 'counted',
        text: 'localInventoriesTable:currentInventory',
        sort: true,
        classes: 'cursor-pointer',
        /*formatter: (cell, row, rowIndex, extraProps) => (
                <>
                  <Form.Control
                        min={0}
                        max={row.serialkey ? 1 : null}
                        type="number"
                        placeholder={row.quantity}
                        //step="0.01"
                        //onChange={e => { extraProps.handleOnChangeCell(e)(row, cell)} }
                        onBlur={e => { extraProps.handleOnChangeCell(e)(row, cell)} }
                        name="countedInp"
                        value={row.counted}
                    />
                </>
              ),*/
        validator: (newValue, row, column) => {
          if (!isNumeric(newValue)) {
            return {
              valid: false,
              message: t('createLocalInventory:specifyNumber'),
            }
          }
          if (row.serialkey && newValue > 1) {
            return {
              valid: false,
              message: t(
                'createLocalInventory:specifySerialkeyOnlySingleQuantity'
              ),
            }
          }
          return true
        },
      },
      {
        isDummyField: true,
        dataField: 'isDummyField',
        text: '',
        sort: false,
        headerClasses: 'checkBox-header-cell',
        classes: 'checkBox-cell',
        editable: (cell, row, rowIndex, colIndex) => {
          return false
        },
        formatter: (cell, row, rowIndex, extraProps) => (
          <span
            role='button'
            onClick={(e) => {
              extraProps.handleRemoveRow(e)(row, cell)
            }}
          >
            <DeleteIcon title={t('delete')} />
          </span>
        ),
      },
    ],
    []
  )
  const handleRemoveRow = useCallback(
    (e) => (row, cell) => {
      handleLocalChangeCheckbox(row.id)
    },
    [handleLocalChangeCheckbox]
  )
  /*const handleOnChangeCell = useCallback((e) => (row, cell) => {
        const { value } = e.target
        console.log("handleOnChangeCell", row, e, cell, e.target)
        console.log("handleOnChangeCell counted", row.counted)
        console.log("handleOnChangeCell value", value)
        let counted  = null
        if(isNumeric(value))
        {
            counted  = parseInt(value)
            if (counted < 0) {
                counted = row.counted
            }
            if(row.serialkey && counted>1) {
                counted = 1
            }
        }
        console.log("handleOnChangeCell value before", row.counted, "<>", counted)
        row.counted = counted
        console.log("handleOnChangeCell value after", row.counted, "<>", counted)
        var inventories = [...modifiedLocalInventories]
        let foundIndex = inventories.findIndex(item => item.id === row.id)
        if(foundIndex>=0)
        {
            inventories[foundIndex].counted = counted
            setModifiedLocalInventories(inventories)
        }
    }, [setModifiedLocalInventories, modifiedLocalInventories])*/
  const handleAfterSaveCell = (oldValue, newValue, row, column) => {
    let counted = parseInt(!isNumeric(newValue) ? oldValue : newValue)
    if (counted < 0) {
      counted = oldValue
    }
    if (row.serialkey && counted > 1) {
      counted = 1
    }
    var inventories = [...modifiedLocalInventories]
    let foundIndex = inventories.findIndex((item) => item.id === row.id)
    if (foundIndex >= 0) {
      inventories[foundIndex].counted = counted
      setModifiedLocalInventories(inventories)
    }
  }
  const preparedColumns = useMemo(() => {
    const tmpColumns = [...columns]
    tmpColumns.forEach((tmpColumn) => {
      tmpColumn.headerFormatter = (column, colIndex, components) => {
        switch (tmpColumn.dataField) {
          default:
            return (
              <>
                <StyledHeaderCell>
                  {column.text}
                  {components.sortElement}
                </StyledHeaderCell>
              </>
            )
        }
      }
    })
    tmpColumns.forEach((tmpColumn) => {
      tmpColumn.text = t(tmpColumn.text)
    })
    /*tmpColumns.find(col => col.dataField === 'counted').formatExtraData = {
            handleOnChangeCell
        }*/
    tmpColumns.find((col) => col.dataField === 'isDummyField').formatExtraData =
      {
        handleRemoveRow,
      }
    const ignoreColumns = () => {
      var result = []
      if (!modifiedLocalInventories.find((x) => !isEmptyGuid(x.sizeId)))
        result.push('sizeName')
      if (!modifiedLocalInventories.find((x) => x.serialkey))
        result.push('serialkey')
      if (!modifiedLocalInventories.find((x) => x.batchKey)) {
        result.push('batchKey')
        result.push('expiryDate')
      }
      return result
    }

    return tmpColumns.filter(
      (item) => !ignoreColumns().includes(item.dataField)
    )
  }, [
    handleRemoveRow,
    /*handleOnChangeCell,*/ columns,
    modifiedLocalInventories,
  ])
  const handleClose = () => {
    //setForceReloadLocalInventories(true)
    setShowUpdateLocalInventoriesModal(false)
  }
  const saveData = async () => {
    let inventoryChanges = modifiedLocalInventories
      .filter((x) => x.counted !== null)
      .map((e) => {
        return {
          storehouseId: e.storehouseId,
          articleId: e.articleId,
          sizeId: e.sizeId,
          serialkey: e.serialkey,
          batchKey: e.batchKey,
          expiryDate: e.expiryDate,
          quantity: e.counted,
        }
      })
    let params = {
      inventoryChanges: inventoryChanges,
      comment: comment,
    }
    return await apiClient.patchJson(
      APIEndpoints.localstock().localInventories,
      params
    )
  }

  const handleSave = async () => {
    setIsSaving(true)
    setError('')
    try {
      await saveData()
      setSuccess(t('EmployeeFormSidebar:dataSaved'))
      resetModifiedSelections()
      setForceReloadLocalInventories(true)
      setShowUpdateLocalInventoriesModal(false)
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    }
    setIsSaving(false)
  }
  return (
    <Modal size='xl' centered show={true} onHide={handleClose} scrollable>
      <Modal.Header closeButton className='pb-0'>
        <Modal.Title>
          <div>
            <p className='m-0 pt-2'>
              {t('adHocInventoryPage:saveAllInventories')}
            </p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UniversalTableWrapperTest>
          <BootstrapTable
            ref={tableRef}
            noDataIndication={() => {
              ;<div className='no-data-placeholder'>No Data</div>
            }}
            bootstrap4
            keyField='id'
            hover
            data={modifiedLocalInventories}
            columns={preparedColumns}
            bordered={false}
            cellEdit={cellEditFactory({
              mode: 'click',
              blurToSave: true,
              afterSaveCell: handleAfterSaveCell,
              autoSelectText: true,
            })}
          />
        </UniversalTableWrapperTest>
        {error ? <Alert variant='danger'>{error}</Alert> : null}
        {success ? <Alert variant='success'>{success}</Alert> : null}
      </Modal.Body>
      <Modal.Footer className='d-flex flex-column flex-md-row align-items-start gap-2'>
        <div className='flex-grow-1 w-100'>
          <Form.Group>
            <Form.Label>{t('comment')}</Form.Label>
            <Form.Control
              as='textarea'
              placeholder=''
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              name='comment'
            />
          </Form.Group>
        </div>
        <ResponsiveButton>
          <ButtonWithLoadingState
            variant='primary'
            buttonText={t('createLocalInventory:saveLocalInventory')}
            isLoading={isSaving}
            onClick={handleSave}
          />
        </ResponsiveButton>
      </Modal.Footer>

      {/* <Modal.Footer>
        <div className='flex-grow-1 bd-highlight'>
          <Form.Group>
            <Form.Label>{t('comment')}</Form.Label>
            <Form.Control
              as='textarea'
              placeholder=''
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              name='comment'
            />
          </Form.Group>
        </div>
        <ButtonWithLoadingState
          variant='primary'
          buttonText={`${t('saveButton')} ${
            modifiedLocalInventories.length
              ? `(${modifiedLocalInventories.length})`
              : ''
          }`}
          loadingText={t('createLocalInventory:saveLocalInventory')}
          isLoading={isSaving}
          onClick={handleSave}
        />
      </Modal.Footer> */}
    </Modal>
  )
}

const UpdateLocalInventories = () => {
  const { modifiedLocalInventories } = useLocalInventoriesState()
  const [showUpdateLocalInventoriesModal, setShowUpdateLocalInventoriesModal] =
    useState(false)

  return (
    <>
      <Button
        className='w-100 mb-3'
        onClick={() => setShowUpdateLocalInventoriesModal(true)}
        disabled={!modifiedLocalInventories.length}
      >
        <MdLibraryAdd className='me-3' />
        {t('adHocInventoryPage:saveAllInventories')}
        {modifiedLocalInventories.length
          ? `(${modifiedLocalInventories.length})`
          : null}
      </Button>
      {showUpdateLocalInventoriesModal ? (
        <UpdateLocalInventoriesModal
          setShowUpdateLocalInventoriesModal={
            setShowUpdateLocalInventoriesModal
          }
        />
      ) : null}
    </>
  )
}
export default UpdateLocalInventories
